import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SelectImportMethod.module.scss';
import LabelButton from '../../../../../components/LabelButton';
import mmIcon from '../../../../../assets/images/metamask.png';
import Clickable from '../../../../../components/Clickable';
import { ImportMethod } from '../../../../../enum';

type Props = {
  onNext: (method: ImportMethod) => void;
}

const SelectImportMethod: React.FC<Props> = ({ onNext }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<ImportMethod | ''>('');
  return (
    <div className={styles.container}>
      <div className={styles.tip}>{t('select_import_method')}</div>
      <div className={styles.list}>
        <Clickable event={() => setSelected(ImportMethod.MetaMask)} label="MetaMask">
          <div className={styles.listItem}>
            <div className={`${styles.methodBox} ${selected === ImportMethod.MetaMask ? styles.active : ''}`}>
              <img src={mmIcon} alt="metamask" />
            </div>
            <div className={styles.label}>MetaMask</div>
          </div>
        </Clickable>
      </div>
      <LabelButton
        label={t('next')}
        disable={selected === ''}
        type="square"
        onClick={() => onNext(selected as ImportMethod)}
      />
    </div>
  );
};

export default SelectImportMethod;
